import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { STORAGE_CONFIG, WINDOW_TOKEN } from 'bcte-common-lib';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { API_CONFIG } from './core/models/api-config.model';
import { SharedFormsModule } from './shared';
import { AuthInterceptor } from './shared/auth/interceptors/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    // Authentication Http Interceptor
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // Server API Configurations
    {
      provide: API_CONFIG,
      useFactory: () => {
        return {
          baseUrl: environment.serverUrl,
          apiUrl: environment.apiUrl
        };
      }
    },
    // {
    //   provide: HTTP_INTERCEPTORS, 
    //   useClass: ApiKeyInterceptor, 
    //   multi: true
    // },
    // Window provider
    {
      provide: WINDOW_TOKEN,
      useFactory: () => window
    },
    // Local storage provider
    {
      provide: STORAGE_CONFIG,
      useFactory: () => ({
        prefix: 'bcte'
      })
    },
    // Mat dialog settings
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        ...new MatDialogConfig(),
        minWidth: '400px'
      }
    },
    importProvidersFrom(SharedFormsModule.forRoot())
  ]
};
